// eslint-disable-next-line import/prefer-default-export
export const STORE_GENERAL_INFO = 'STORE_GENERAL_INFO';
export const STORE_SYSTEM_INFO = 'STORE_SYSTEM_INFO';
export const STORE_COUNTRIES = 'STORE_COUNTRIES';